import React, { useState } from "react";
import { API } from "@/lib/api";

export const brandLogoUrl = (id, v) => (id ? `${API}/brands/${id}/logo${v ? `?v=${encodeURIComponent(v)}` : ""}` : null);

export function BrandMark({ id, name, version, size = 20, className = "" }) {
  const [failed, setFailed] = useState(false);
  const style = { height: size, width: size, fontSize: Math.max(9, size * 0.45) };
  if (id && !failed) return <img src={brandLogoUrl(id, version)} alt="" onError={() => setFailed(true)} style={style} className={`rounded-md object-cover border border-[#EEEFEF] bg-white shrink-0 ${className}`} />;
  return <span style={style} className={`rounded-md bg-[#EDE7FF] text-[#5b2fd6] font-semibold flex items-center justify-center shrink-0 ${className}`}>{(name || "?").charAt(0).toUpperCase()}</span>;
}

export function BrandTag({ project, testid }) {
  if (!project?.brand_id) return null;
  return (
    <span data-testid={testid} className="inline-flex items-center gap-1.5 rounded-full border border-[#EEEFEF] bg-white pl-0.5 pr-2 py-0.5 text-[11px] text-[#595D62] max-w-[160px]">
      <BrandMark id={project.brand_id} name={project.brand_name} size={16} className="rounded-full" />
      <span className="truncate">{project.brand_name}</span>
    </span>
  );
}
